function hasValue(value: unknown): boolean {
    return (
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ""
    );
}

function toNumber(value: unknown): number {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : 0;
}
export function setStats(pos: any, statsP: any, idPlayer: any) {
    var array: any = [];
    if (pos === "1" || pos === "2" || pos === "3") {
            statsP.push({
            id: idPlayer,
            att: 0,
            comp: 0,
            ydsPas: 0,
            tdsPas: 0,
            int: 0,
            qbr: 0,
            attA: 0,
            ydsAca: 0,
            tdsAca: 0,
            fumble: 0,
            attR: 0,
            compR: 0,
            ydsRec: 0,
            tdsRec: 0,
            attK: 0,
            ydsK: 0,
            attP: 0,
            ydsP: 0,
            tdsK: 0,
            tdsP: 0
        });
    } else if (pos === "4" || pos === "5" || pos === "6") {
        statsP.push({
            id: idPlayer,
            tkl: 0,
            assTkl: 0,
            sack: 0,
            asSack: 0,
            int: 0,
            ff: 0,
            fr: 0,
            td: 0,
            pd: 0,
            pb: 0,
            tklL: 0
        });
    } else if (pos === "7") {
        statsP.push({
            id: idPlayer,
            attFG: 0,
            attXP: 0,
            ydsFG: 0,
            compFG: 0,
            compXP: 0,
            punt: 0,
            ydsP: 0,
            blqK: 0,
            blqP: 0
        });
    }
};
export function setStatsGame(pos: any, statsP: any[], idPlayer: any, idOponent: any) {
    if (idOponent != "") {
    if (pos === "1" || pos === "2" || pos === "3") {
            statsP.push({
            id: idPlayer,
            idOponent: idOponent,
            att: 0,
            comp: 0,
            ydsPas: 0,
            tdsPas: 0,
            int: 0,
            qbr: 0,
            attA: 0,
            ydsAca: 0,
            tdsAca: 0,
            fumble: 0,
            attR: 0,
            compR: 0,
            ydsRec: 0,
            tdsRec: 0,
            attK: 0,
            ydsK: 0,
            attP: 0,
            ydsP: 0,
            tdsK: 0,
            tdsP: 0
        });
    } else if (pos === "4" || pos === "5" || pos === "6") {
        statsP.push({
            id: idPlayer,
            idOponent: idOponent,
            tkl: 0,
            assTkl: 0,
            sack: 0,
            asSack: 0,
            int: 0,
            ff: 0,
            fr: 0,
            td: 0,
            pd: 0,
            pb: 0,
            tklL: 0
        });
    } else if (pos === "7") {
        statsP.push({
            id: idPlayer,
            idOponent: idOponent,
            attFG: 0,
            attXP: 0,
            ydsFG: 0,
            compFG: 0,
            compXP: 0,
            punt: 0,
            ydsP: 0,
            blqK: 0,
            blqP: 0
        });
    }
    }
};
export function setStatsTeam(teams: any, array: any) {
    teams.map((team: { id: any; }) => {
        setStatsTeamAlt(team.id, array)
    })
}
export function setStatsTeamAlt(teamId: any, array: any) {
    array.push({
        id: teamId,
        rush: 0,
        pass: 0,
        tdR: 0,
        tdP: 0,
        rushD: 0,
        passD: 0,
        tdRD: 0,
        tdPD: 0,
        fr: 0,
        int: 0,
        attXp: 0,
        xp: 0,
        attFg: 0,
        fg: 0,
        ydsKR: 0,
        ydsPR: 0,
        tdKR: 0,
        tdPR: 0,
        kb: 0,
        sack: 0,
        conv: 0,
        attR: 0,
        attP: 0,
        comp: 0,
        penOff: 0,
        penDef: 0,
        ydPenOff: 0,
        ydPenDef: 0,
    });
}
export function getOfence(element: any, array:any) {
    if (hasValue(element.WR) && element.yds != "") {
        array.forEach((team: {
            attP: any;
            comp: any;
            conv: any;
            tdP: any;
            pass: any; id: any; 
        }) => {
            if (team.id == element.ofensiva) {
                if (element.td != "2" && element.td != "0") {
                    team.pass = team.pass + toNumber(element.yds)
                    team.comp++
                    team.attP++
                    if (element.pitch != null) {
                        if (element.pf == "1") {
                            team.pass = team.pass + parseInt(element.ydsPitch)
                        }
                    }
                }
                if (element.td === "6") {
                    team.tdP++
                } else if (element.td === "2") {
                    team.conv++
                }
            }
        });
    } else if (hasValue(element.RB)) {
        array.forEach((team: {
            attR: any;
            conv: any;
            tdR: any;
            rush: any; id: any; 
        }) => {
            if (team.id == element.ofensiva) {
                if (element.td != "2" && element.td != "0") {
                    team.rush = team.rush + toNumber(element.yds)
                    team.attR++
                    if (element.pitch != null) {
                        if (element.pf == "1") {
                            team.rush = team.rush + parseInt(element.ydsPitch)
                        }
                    }
                }
                if (element.td === "6") {
                    team.tdR++
                }else if (element.td === "2") {
                    team.conv++
                }
            }
        });
    } else if (hasValue(element.QB)) {
        array.forEach((team: {
            attP: any;
            conv: any;
            tdR: any;
            rush: any; id: any; 
        }) => {
            if (team.id == element.ofensiva) {
                if (element.td != "2" && element.td != "0") {
                    if (element.sack == "" && element.int == "") {
                        team.attP++
                    }
                }
            }
        });
    }
}
export function getDefencee(element: any, array:any, idTeam: any) {
    if (element.td != "2" && element.td != "0") {
        if (hasValue(element.int)) {    
            array.forEach((team: {
                int: any; id: any; 
            }) => {
                if (team.id == idTeam) {
                    team.int++
                }
            });
        } else if (hasValue(element.sack)) {    
            array.forEach((team: {
                fr: any;
                sack: any; id: any; 
            }) => {
                if (team.id == idTeam) {
                    team.sack++
                    if (element.fumbleR != "") {
                        team.fr++
                    }
                }
            });
        } else if (hasValue(element.WR) && element.yds != "") {
            array.forEach((team: {
                fr: any;
                tdPD: any;
                passD: any; id: any; 
            }) => {
                if (team.id == idTeam) {
                    team.passD = team.passD + toNumber(element.yds)
                    if (element.pitch != null) {
                        if (element.pf == "1") {
                            team.passD = team.passD + parseInt(element.ydsPitch)
                        }
                    }
                    if (element.td === "6") {
                        team.tdPD++
                    } else if (element.fumbleR != "") {
                        team.fr++
                    }
                }
            });
        } else if (hasValue(element.RB)) {
            array.forEach((team: {
                fr: any;
                tdRD: any;
                rushD: any; id: any; 
            }) => {
                if (team.id == idTeam) {
                    team.rushD = team.rushD + toNumber(element.yds)
                    if (element.pitch != null) {
                        if (element.pf == "1") {
                            team.rushD = team.rushD + parseInt(element.ydsPitch)
                        }
                    }
                    if (element.td === "6") {
                        team.tdRD++
                    } else if (element.fumbleR != "") {
                        team.fr++
                    }
                }
            });
        }
    }
}
export function getSpecialK(element: any, array:any) {
    if (hasValue(element.K)) {
        if (element.d != null) {
            if (element.d == "5") {
                array.forEach((team: {
                    attXp: any;
                    xp: any; id: any; 
                }) => {
                    if (team.id == element.ofensiva) {
                        team.attXp++
                        if (element.td === "1") {
                            team.xp++
                        }
                    }
                });
            } else if (element.d != "0") {
                if (element.td != "") {
                    array.forEach((team: {
                        attFg: any;
                        fg: any; id: any; 
                    }) => {
                        if (team.id == element.ofensiva) {
                            team.attFg++
                            if (element.td === "3") {
                                team.fg++
                            }
                        }
                    });
                }
            }
        } else {

        }
    }
}
export function getSpecialR(element: any, array:any, idTeam:any) {
    if (hasValue(element.K)) {
        if (element.d != null) {
            if (element.kickBlq != "" && element.td != "") {
                array.forEach((team: {
                    kb: any; id: any; 
                }) => {
                    if (team.id == idTeam) {
                        team.kb++
                    }
                });
            } else if (element.ret != "") {
                if (element.d == "0") {
                    array.forEach((team: {
                        ydsKR: any; id: any; tdKR: any; 
                    }) => {
                        if (team.id == idTeam) {
                            team.ydsKR = team.ydsKR + parseInt(element.retYds)
                            if (element.retTd != "") {
                                team.tdKR++
                            }
                        }
                    });
                } else {
                    array.forEach((team: {
                        ydsPR: any; id: any; tdPR: any; 
                    }) => {
                        if (team.id == idTeam) {
                            team.ydsPR = team.ydsPR + parseInt(element.retYds)
                            if (element.retTd != "") {
                                team.tdPR++
                            }
                        }
                    });

                }
            }
        }
    }
}
export function getPenalty(element: any, array:any) {
    if (element.C != null && element.C != "") {
        array.forEach((team: {
            penDef: any;
            ydPenDef: number;
            ydPenOff: number;
            penOff: any;
            id: any; 
        }) => {
            if (team.id == element.ofensiva) {
                if (element.od == "0") {
                    team.ydPenOff += toNumber(element.yds)
                    team.penOff++
                } else {
                    team.ydPenDef += toNumber(element.yds)
                    team.penDef++
                }
            }
        });
    }
}

function isDefensiveTouchdown(element: any): boolean {
    return element.deftd === "6";
}

function getDefensiveScorer(element: any): string {
    if (!isDefensiveTouchdown(element)) {
        return "";
    }

    /*
        Prioridad:
        1. Jugador que recuperó el fumble.
        2. Jugador que interceptó.
        3. Tacleador, para los registros donde el touchdown
           está asociado a la tacleada.
        4. Jugador que realizó el sack.
    */
    return (
        element.fumbleR ||
        element.int ||
        element.tkl ||
        element.sack ||
        ""
    );
}

export function getA(att: number, comp: number){
    var a = ((comp/att) - 0.3) * 5;

    if(a > 0 && a < 2.375){
        return a;
    }else if( a >= 2.375){
        return 2.375;
    }
    return 0;
}
export function getB(att: number, yds: number){
    var b = ((yds/att) - 3) * 0.25;

    if(b > 0 && b < 2.375){
        return b;
    }else if( b >= 2.375){
        return 2.375;
    }
    return 0;
}
export function getC(att: number, tds: number){
    var c = (tds/att) * 20;

    if(c > 0 && c < 2.375){
        return c;
    }else if( c >= 2.375){
        return 2.375;
    }
    return 0;
}
export function getD(att: number, int: number){
    var d = 2.375 - (int/att) * 25;

    if(d > 0 && d < 2.375){
        return d;
    }else if( d >= 2.375){
        return 2.375;
    }
    return 0;
}
export function getQBR(att: any, comp: any, yds: any, tds: any, int: any){
    if (!att) {
        return "0.0";
    }

    var a = getA(att, comp);
    var b = getB(att, yds);
    var c = getC(att, tds);
    var d = getD(att, int);
    var q = a+b+c+d;

    return (100*(q/6)).toFixed(1);
}
export function getQB(element: any, statsP: any[]){
    if(hasValue(element.QB) && (element.td != "2" && element.td != "0")){
        var flag = 0;
        if(statsP.length < 1){
            setStats("1", statsP, element.QB);
        }
        statsP.forEach(player => {
            if(player.id === element.QB){
                if(element.sack == ""){
                    player.att++;
                }
                if(element.yds != ""){
                    player.comp++;
                    player.ydsPas = player.ydsPas + toNumber(element.yds);
                    if(element.td === "6"){
                        player.tdsPas++;
                    }
                    if (element.pitch != null) {
                        if (element.ydsPitch != "" && element.pf == "1") {
                            player.ydsPas = player.ydsPas + parseInt(element.ydsPitch);
                        }
                    }
                } else if (hasValue(element.int)) {
                    player.int++;
                } else if((element.fumbleF != "" || element.fumbleR != "") && element.WR == "" ){
                    player.fumble++;
                }
                flag = 1;
            }
        });
        if(!flag){
            setStats("1", statsP, element.QB);
            statsP.forEach(player => {
                if(player.id === element.QB){
                    if(element.sack == ""){
                        player.att++;
                    }
                    if(element.yds != ""){
                        player.comp++;
                        player.ydsPas = player.ydsPas + toNumber(element.yds);
                        if(element.td === "6"){
                            player.tdsPas++;
                        }
                        if (element.pitch != null) {
                            if (element.ydsPitch != "" && element.pf == "1") {
                                player.ydsPas = player.ydsPas + parseInt(element.ydsPitch);
                            }
                        }
                    } else if (hasValue(element.int)) {
                        player.int++;
                    } else if((element.fumbleF != "" || element.fumbleR != "") && element.WR == "" ){
                        player.fumble++;
                    }
                }
            });
        }
    }
}
export function getRB(element: any, statsP: any[]){
    if(hasValue(element.RB) && (element.td != "2" && element.td != "0")){
        var flag = 0;
        if(statsP.length < 1){
            setStats("2", statsP, element.RB);
        }
        statsP.forEach(player => {
            if(player.id === element.RB){
                player.attA++;
                if(element.yds != ""){
                    player.ydsAca = player.ydsAca + toNumber(element.yds);
                    if (element.td === "6") {
                        if (element.pitch != null) {
                            if(element.pf === "0"){
                                player.tdsAca++;
                            }
                        } else {
                            player.tdsAca++;
                        }
                    }
                }
                if (element.fumbleF != "" || element.fumbleR != "") {
                    if (element.pitch != null) {
                        if(element.pf == "0"){
                            player.fumble++;
                        }
                    } else {
                        player.fumble++;
                    }
                } 
                if (element.pitch != null) {
                    if (element.pf == "2" && (element.fumbleF == "" && element.fumbleR == "")) {
                        player.fumble++;
                    }
                }
                flag = 1;
            }
        });
        if(!flag){
            setStats("2", statsP, element.RB);
            statsP.forEach(player => {
                if(player.id === element.RB){
                    player.attA++;
                    if(element.yds != ""){
                        player.ydsAca = player.ydsAca + toNumber(element.yds);
                        if(element.td === "6"){
                            if (element.pitch != null) {
                                if(element.pf === "0"){
                                    player.tdsAca++;
                                }
                            } else {
                                player.tdsAca++;
                            }
                        }
                    } 
                    if (element.fumbleF != "" || element.fumbleR != "") {
                        if (element.pitch != null) {
                            if (element.pf == "0") {
                                player.fumble++;
                            }
                        } else {
                            player.fumble++;
                        }
                    }
                    if (element.pitch != null) {
                        if (element.pf == "2" && (element.fumbleF == "" && element.fumbleR == "")) {
                            player.fumble++;
                        }
                    }
                }
            });
        }
        if(element.pitch != null && element.pitch != "" &&  element.pf === "1"){
            var flag = 0;
            if (statsP.length < 1) {
                setStats("2", statsP, element.pitch);
            }
            statsP.forEach(player => {
                if(player.id === element.pitch){
                    if(element.ydsPitch != ""){
                        player.ydsAca = player.ydsAca + parseInt(element.ydsPitch);
                        if (element.td === "6") {
                            player.tdsAca++;
                        }
                        if (element.fumbleF != "" || element.fumbleR != "") {
                            player.fumble++;
                        }
                    }
                    flag = 1;
                }
            });
            if(!flag){
                setStats("2", statsP, element.pitch);
                statsP.forEach(player => {
                    if(player.id === element.pitch){
                    if(element.ydsPitch != ""){
                        player.ydsAca = player.ydsAca + parseInt(element.ydsPitch);
                        if (element.td === "6") {
                            player.tdsAca++;
                        }
                        if(element.fumbleF != "" || element.fumbleR != ""){
                            player.fumble++;
                        }
                    }
                    flag = 1;
                }
                });
            }
        }
    }
}
export function getWR(element: any, statsP: any[]){
    if(hasValue(element.WR) && (element.td != "2" && element.td != "0")){
        console.log(element.td)
        var flag = 0;
        if(statsP.length < 1){
            setStats("3", statsP, element.WR);
        }
        statsP.forEach(player => {
            if(player.id === element.WR){
                player.attR++;
                if(element.yds != ""){
                    player.compR++;
                    player.ydsRec = player.ydsRec + toNumber(element.yds);
                    if(element.td === "6"){
                        if (element.pitch != null) {
                            if(element.pf == "0"){
                                player.tdsRec++;
                            }
                        } else {
                            player.tdsRec++;
                        }
                    }
                    if(element.fumbleF != "" || element.fumbleR != ""){
                        if (element.pitch != null) {
                            if (element.pf == "0") {
                                player.fumble++;
                            }
                        } else {
                            player.fumble++;
                        }
                    }
                    if (element.pitch != null) {
                        if (element.pf == "2" && (element.fumbleF == "" && element.fumbleR == "")) {
                            player.fumble++;
                        }
                    }
                }
                flag = 1;
            }
        });
        if(!flag){
            setStats("3", statsP, element.WR);
            statsP.forEach(player => {
                if(player.id === element.WR){
                    player.attR++;
                    if(element.yds != ""){
                    player.compR++;
                    player.ydsRec = player.ydsRec + toNumber(element.yds);
                    if(element.td === "6"){
                        if (element.pitch != null) {
                            if(element.pf == "0"){
                                player.tdsRec++;
                            }
                        } else {
                            player.tdsRec++;
                        }
                    }
                    if (element.fumbleF != "" || element.fumbleR != "") {
                        player.fumble++;
                    }
                    if (element.pitch != null) {
                        if (element.pf == "2" && (element.fumbleF == "" && element.fumbleR == "")) {
                            player.fumble++;
                        }
                    }
                    }
                }
            });
        }
        if (element.pitch != null) {
            if (element.pitch != "" && element.pf == "1") {
                var flag = 0;
                if(statsP.length < 1){
                    setStats("3", statsP, element.pitch);
                }
                statsP.forEach(player => {
                    if(player.id === element.pitch){
                        if(element.ydsPitch != ""){
                            player.ydsRec = player.ydsRec + parseInt(element.ydsPitch);
                            if(element.td === "6"){
                                player.tdsRec++;
                            }
                            if(element.fumbleF != "" || element.fumbleR != ""){
                               player.fumble++;
                            }
                        }
                        flag = 1;
                    }
                });
                if(!flag){
                    setStats("3", statsP, element.pitch);
                    statsP.forEach(player => {
                        if(player.id === element.pitch){
                            if(element.ydsPitch != ""){
                                player.ydsRec = player.ydsRec + parseInt(element.ydsPitch);
                                if(element.td === "6"){
                                    player.tdsRec++;
                                }
                                if(element.fumbleF != "" || element.fumbleR != ""){
                                    player.fumble++;
                                }
                            }
                        }
                    });
                }
            }
        }
    }
}
export function getDEF(element: any, statsP: any[]){
    if ((element.td != "2" && element.td != "0")) {
        if(hasValue(element.tkl)){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.tkl);
            }
            statsP.forEach( player => {
                if (player.id == element.tkl) {
                player.tkl++;
                if (toNumber(element.yds) < 0) {
                    player.tklL++;
                }
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.tkl);
                statsP.forEach( player => {
                if (player.id == element.tkl) {
                    player.tkl++;
                    if (toNumber(element.yds) < 0) {
                        player.tklL++;
                    }
                    }
                });
            }
        }
        if(element.assTkl != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.assTkl);
            }
            statsP.forEach( player => {
                if (player.id == element.assTkl) {
                player.assTkl++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.assTkl);
                    statsP.forEach( player => {
                    if (player.id == element.assTkl) {
                    player.assTkl++;
                    }
                });
            }
        }
        if(element.assTkll != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.assTkll);
            }
            statsP.forEach( player => {
                if (player.id == element.assTkll) {
                player.assTkl++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.assTkll);
                    statsP.forEach( player => {
                    if (player.id == element.assTkll) {
                    player.assTkl++;
                    flag = 1;
                    }
                });
            }
        }
        if(hasValue(element.sack)){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.sack);
            }
            statsP.forEach( player => {
                if (player.id == element.sack) {
                if (element.assSack === "") {
                    player.sack++;
                    player.tkl++;
                    player.tklL++;
                } else {
                    player.asSack++;
                    player.assTkl++;
                }
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.sack);
                statsP.forEach( player => {
                if (player.id === element.sack) {
                    if (element.assSack === "") {
                        player.sack++;
                        player.tkl++;
                        player.tklL++;
                        } else {
                        player.asSack++;
                        player.assTkl++;
                        }
                        flag = 1;
                    }
                    flag = 1;
                });
            }
        }
        if(element.assSack != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.assSack);
            }
            statsP.forEach( player => {
                if (player.id == element.assSack) {
                player.asSack++;
                player.assTkl++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.assSack);
                statsP.forEach( player => {
                if (player.id == element.assSack) {
                    player.asSack++;
                    player.assTkl++;
                    flag = 1;
                    }
                });
            }
        }  
        if(element.assSackk != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.assSackk);
            }
            statsP.forEach( player => {
                if (player.id == element.assSackk) {
                player.asSack++;
                player.assTkl++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.assSackk);
                statsP.forEach( player => {
                    if (player.id == element.assSackk) {
                    player.asSack++;
                    player.assTkl++;
                    flag = 1;
                    }
                });
            }
        }
        if(element.fumbleF != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.fumbleF);
            }
            statsP.forEach( player => {
                if (player.id == element.fumbleF) {
                player.ff++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.fumbleF);
                statsP.forEach( player => {
                    if (player.id == element.fumbleF) {
                    player.ff++;
                    flag = 1;
                    }
                });
            }
        }
        if(element.fumbleR != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.fumbleR);
            }
            statsP.forEach( player => {
                if (player.id == element.fumbleR) {
                player.fr++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.fumbleR);
                statsP.forEach( player => {
                    if (player.id == element.fumbleR) {
                    player.fr++;
                    flag = 1;
                    }
                });
            }
        }
        if(hasValue(element.int)){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.int);
            }
            statsP.forEach( player => {
                if (player.id == element.int) {
                player.int++;
                player.pd++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.int);
                statsP.forEach( player => {
                    if (player.id == element.int) {
                    player.int++;
                    player.pd++;
                    flag = 1;
                    }
                });
            }
        }
        if(element.passDef != ""){
            var flag = 0;
                if(statsP.length < 1){
                    setStats("4", statsP, element.passDef);
                }
                statsP.forEach( player => {
                    if (player.id == element.passDef) {
                    player.pd++;
                    flag = 1;
                    }
                });
                if (!flag) {
                    setStats("4", statsP, element.passDef);
                    statsP.forEach( player => {
                    if (player.id == element.passDef) {
                    player.pd++;
                    flag = 1;
                    }
                });
            }
        }
        if(element.deftd != ""){
            var flag = 0;
                if(statsP.length < 1){
                    setStats("4", statsP, element.deftd);
                }
                statsP.forEach( player => {
                    if (player.id == element.deftd) {
                    player.td++;
                    flag = 1;
                    }
                });
                if (!flag) {
                    setStats("4", statsP, element.deftd);
                    statsP.forEach( player => {
                    if (player.id == element.deftd) {
                    player.td++;
                    flag = 1;
                    }
                });
            }
        }
        if(element.kickBlq != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.kickBlq);
            }
            statsP.forEach( player => {
                if (player.id == element.kickBlq) {
                player.pb++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.kickBlq);
                statsP.forEach( player => {
                if (player.id == element.kickBlq) {
                player.pb++;
                flag = 1;
                }
            });
            }
        }
    } else {
        if(element.kickBlq != ""){
            var flag = 0;
            if(statsP.length < 1){
                setStats("4", statsP, element.kickBlq);
            }
            statsP.forEach( player => {
                if (player.id == element.kickBlq) {
                player.pb++;
                flag = 1;
                }
            });
            if (!flag) {
                setStats("4", statsP, element.kickBlq);
                statsP.forEach( player => {
                if (player.id == element.kickBlq) {
                player.pb++;
                flag = 1;
                }
            });
            }
        }
    }
    const defensiveScorer = getDefensiveScorer(element);

if (defensiveScorer) {
    let player = statsP.find(function (stat) {
        return stat.id === defensiveScorer;
    });

    if (!player) {
        setStats("4", statsP, defensiveScorer);

        player = statsP.find(function (stat) {
            return stat.id === defensiveScorer;
        });
    }

    if (player) {
        player.td++;
    }
}

}
export function getSt(element: any, statsP: any[]) {
    if (element.ret != "") {
        if (element.d != null) {
            if (element.d != "0") {
                var flag = 0;
                if(statsP.length < 1){
                    setStats("1", statsP, element.ret);
                }
                statsP.forEach( player => {
                    if (player.id == element.ret) {
                        player.attP++;
                    if (element.retYds != "") {
                        player.ydsP = player.ydsP + parseInt(element.retYds)
                    }
                    if (element.retTd != "") {
                        if (element.pitch != null) {
                            if (element.pitch === "") {
                                player.tdsP++
                            }
                        } else {
                            player.tdsP++
                        }
                    }
                    flag = 1;
                    }
                });
                if (!flag) {
                    setStats("1", statsP, element.ret);
                    statsP.forEach( player => {
                        if (player.id == element.ret) {
                            player.attP++;
                        if (element.retYds != "") {
                            player.ydsP = player.ydsP + parseInt(element.retYds)
                        }
                        if (element.retTd != "") {
                            if (element.pitch != null) {
                                if (element.pitch == "") {
                                    player.tdsP++
                                }
                            } else {
                                player.tdsP++
                            }
                        }
                        flag = 1;
                        }
                    });
                }
            } else {
                var flag = 0;
                if(statsP.length < 1){
                    setStats("1", statsP, element.ret);
                }
                statsP.forEach( player => {
                    if (player.id == element.ret) {
                        player.attK++;
                    if (element.retYds != "") {
                        player.ydsK = player.ydsK + parseInt(element.retYds)
                    }
                    if (element.retTd != "") {
                        if (element.pitch != null) {
                            if (element.pitch == "") {
                                player.tdsK++
                            }
                        } else {
                            player.tdsK++
                        }
                    }
                    flag = 1;
                    }
                });
                if (!flag) {
                    setStats("1", statsP, element.ret);
                    statsP.forEach( player => {
                        if (player.id == element.ret) {
                            player.attK++;
                        if (element.retYds != "") {
                            player.ydsK = player.ydsK + parseInt(element.retYds)
                        }
                        if (element.retTd != "") {
                            if (element.pitch != null) {
                                if (element.pitch == "") {
                                    player.tdsK++
                                }
                            } else {
                                player.tdsK++
                            }
                        }
                        flag = 1;
                        }
                    });
                }
            }
        } else {
            if (element.ret != "") {
                var flag = 0;
                if(statsP.length < 1){
                    setStats("1", statsP, element.ret);
                }
                statsP.forEach( player => {
                    if (player.id == element.ret) {
                        player.attK++;
                    if (element.retYds != "") {
                        player.ydsK = player.ydsK + parseInt(element.retYds)
                    }
                    if (element.retTd != "") {
                        player.tdsK++
                    }
                    flag = 1;
                    }
                });
                if (!flag) {
                    setStats("1", statsP, element.ret);
                    statsP.forEach( player => {
                        if (player.id == element.ret) {
                            player.attK++;
                        if (element.retYds != "") {
                            player.ydsK = player.ydsK + parseInt(element.retYds)
                        }
                        if (element.retTd != "") {
                            player.tdsK++
                        }
                        flag = 1;
                        }
                    });
                }
            }
        }
        if (element.pitch != null) {
            if (element.pitch != "" && element.pf == "1") {
                if (element.d != "0") {
                    var flag = 0;
                    if(statsP.length < 1){
                        setStats("1", statsP, element.pitch);
                    }
                    statsP.forEach( player => {
                        if (player.id == element.pitch) {
                            if (element.ydsPitch != "") {
                                player.ydsP = player.ydsP + parseInt(element.ydsPitch)
                            }
                            if (element.retTd != "") {
                                player.tdsP++
                            }
                            flag = 1;
                        }
                    });
                    if (!flag) {
                        setStats("1", statsP, element.pitch);
                        statsP.forEach( player => {
                            if (player.id == element.pitch) {
                            if (element.ydsPitch != "") {
                                player.ydsP = player.ydsP + parseInt(element.ydsPitch)
                            }
                            if (element.retTd != "") {
                                 player.tdsP++
                            }
                            flag = 1;
                            }
                        });
                    }
                } else {
                    var flag = 0;
                    if(statsP.length < 1){
                        setStats("1", statsP, element.pitch);
                    }
                    statsP.forEach( player => {
                        if (player.id == element.pitch) {
                            player.attK++;
                        if (element.ydsPitch != "") {
                            player.ydsK = player.ydsK + parseInt(element.ydsPitch)
                        }
                        if (element.retTd != "") {
                            player.tdsK++
                        }
                        flag = 1;
                        }
                    });
                    if (!flag) {
                        setStats("1", statsP, element.pitch);
                        statsP.forEach( player => {
                            if (player.id == element.pitch) {
                                player.attK++;
                            if (element.ydsPitch != "") {
                                player.ydsK = player.ydsK + parseInt(element.ydsPitch)
                            }
                            if (element.retTd != "") {
                                player.tdsK++
                            }
                            flag = 1;
                            }
                        });
                    }
                }
            }
        }
    }
}
export function getK(element: any, statsP: any[]) {
    if (hasValue(element.K)) {
        if (element.d != null) {
            if (element.d == "5") {
                var flag = 0;
                if(statsP.length < 1){
                    setStats("7", statsP, element.K);
                }
                statsP.forEach( player => {
                    if (player.id == element.K) {
                        player.attXP++
                        if (element.td == "1") {
                            player.compXP++
                        }
                        if (element.kickBlq != "") {
                            player.blqK++
                        }
                        flag = 1
                    }
                });
                if (!flag) {
                    setStats("7", statsP, element.K);
                    statsP.forEach( player => {
                        if (player.id == element.K) {
                             player.attXP++
                            if (element.td == "1") {
                                player.compXP++
                            }
                            if (element.kickBlq != "") {
                                player.blqK++
                            }
                            flag = 1
                        }
                    })
                }
            } else if (element.d != "0") {
                if (element.td == "") {
                    var flag = 0;
                    if(statsP.length < 1){
                        setStats("7", statsP, element.K);
                    }
                    statsP.forEach( player => {
                        if (player.id == element.K) {
                            player.punt++
                            player.ydsP = player.ydsP + toNumber(element.yds)
                            if (element.kickBlq != "") {
                                player.blqP++
                            }
                            flag = 1
                        }
                    });
                    if (!flag) {
                        setStats("7", statsP, element.K);
                        statsP.forEach( player => {
                            if (player.id == element.K) {
                                player.punt++
                                player.ydsP = player.ydsP + toNumber(element.yds)
                                if (element.kickBlq != "") {
                                    player.blqP++
                                }
                                flag = 1
                            }
                        })
                    }
                } else {
                    var flag = 0;
                    if(statsP.length < 1){
                        setStats("7", statsP, element.K);
                    }
                    statsP.forEach( player => {
                        if (player.id == element.K) {
                            player.attFG++
                            if (element.td === "3") {
                                player.compFG++
                                if (toNumber(element.yds) > player.ydsFG) {
                                    player.ydsFG = toNumber(element.yds)
                                }
                            }
                            if (element.kickBlq != "") {
                                player.blqK++
                            }
                            flag = 1
                        }
                    });
                    if (!flag) {
                        setStats("7", statsP, element.K);
                        statsP.forEach( player => {
                            if (player.id == element.K) {
                                player.attFG++
                                if (element.td === "3") {
                                    player.compFG++
                                    if (toNumber(element.yds) > player.ydsFG) {
                                        player.ydsFG = toNumber(element.yds)
                                    }
                                }
                                if (element.kickBlq != "") {
                                    player.blqK++
                                }
                            }
                        })
                    }
                }
            }
        }
    }
}
export function compareydP( a: { ydsPas: any; }, b: { ydsPas: any;} ) {
    if ( a.ydsPas > b.ydsPas ){
        return -1;
    }
    if ( a.ydsPas < b.ydsPas ){
        return 1;
    }
    return 0;
}
export function compareOff( a: { rush: any;  pass: any; }, b: { rush: any; pass: any;} ) {
    if ( (a.rush + a.pass) > (b.rush + b.pass) ){
        return -1;
    }
    if ( (a.rush + a.pass) < (b.rush + b.pass) ){
        return 1;
    }
    return 0;
}
export function compareDef( a: { rushD: any;  passD: any; }, b: { rushD: any; passD: any;} ) {
    if ( (a.rushD + a.passD) < (b.rushD + b.passD) ){
        return -1;
    }
    if ( (a.rushD + a.passD) > (b.rushD + b.passD) ){
        return 1;
    }
    return 0;
}
export function compareSt( a: { ydsK: any; ydsP: any; }, b: { ydsK: any; ydsP: any;} ) {
    if ( (a.ydsK + a.ydsP) > (b.ydsK + b.ydsP) ){
        return -1;
    }
    if ( (a.ydsK + a.ydsP) < (b.ydsK + b.ydsP) ){
        return 1;
    }
    return 0;
}
export function compareStalt( a: { ydsKR: any; ydsPR: any; }, b: { ydsKR: any; ydsPR: any;} ) {
    if ( (a.ydsKR + a.ydsPR) > (b.ydsKR + b.ydsPR) ){
        return -1;
    }
    if ( (a.ydsKR + a.ydsPR) < (b.ydsKR + b.ydsPR) ){
        return 1;
    }
    return 0;
}
export function compareTkl( a: {
    assTkl: any; tkl: any; 
}, b: {
    assTkl: any; tkl: any;
} ) {
    if ( (a.tkl + a.assTkl) > (b.tkl + b.assTkl) ){
        return -1;
    }
    if ( (a.tkl + a.assTkl) < (b.tkl + b.assTkl) ){
        return 1;
    }
    return 0;
}
export function compareK( a: {
    compFG: any; compXP: any; 
}, b: {
    compFG: any; compXP: any;
} ) {
    if ( ((a.compFG * 3) + a.compXP) > ((b.compFG * 3) + b.compXP) ){
        return -1;
    }
    if ( ((a.compFG * 3) + a.compXP) < ((b.compFG * 3) + b.compXP) ){
        return 1;
    }
    return 0;
}
export function compareydA( a: { ydsAca: any; }, b: { ydsAca: any;} ) {
    if ( a.ydsAca > b.ydsAca ){
        return -1;
    }
    if ( a.ydsAca < b.ydsAca ){
        return 1;
    }
    return 0;
}
export function compareydR( a: { ydsRec: any; }, b: { ydsRec: any;} ) {
    if ( a.ydsRec > b.ydsRec ){
        return -1;
    }
    if ( a.ydsRec < b.ydsRec ){
        return 1;
    }
    return 0;
}
export function getAvg(yds: any, att: any) {
    if (yds == 0 && att == 0) {
    return 0
    }
    if (att == 0) {
    return yds
    }
    return (yds/att).toFixed(1)
}